import type { ReactNode } from "react";

import { cn } from "@/shared/lib/cn";

interface CardProps {
  title?: ReactNode;
  children: ReactNode;
  className?: string;
}

export function Card({ title, children, className }: CardProps) {
  return (
    <section
      className={cn(
        "rounded-lg border border-slate-200 bg-white p-6 shadow-sm",
        "dark:border-slate-800 dark:bg-slate-900",
        className,
      )}
    >
      {title !== undefined && (
        <h2 className="mb-4 text-sm font-semibold tracking-wide text-slate-500 uppercase dark:text-slate-400">
          {title}
        </h2>
      )}
      {children}
    </section>
  );
}

interface DefinitionListProps {
  items: { label: string; value: ReactNode }[];
}

export function DefinitionList({ items }: DefinitionListProps) {
  return (
    <dl className="grid gap-3 sm:grid-cols-2">
      {items.map((item) => (
        <div key={item.label}>
          <dt className="text-xs text-slate-500 dark:text-slate-400">{item.label}</dt>
          <dd className="font-mono text-sm">{item.value}</dd>
        </div>
      ))}
    </dl>
  );
}
